<template>
  <!-- 次要显示的内容 -->
  <yxtf-tooltip
    placement="top"
    open-filter
    class="ellipsis"
    :popper-options="popperOptions"
  >
    <div slot="content">
      <div :style="{ 'max-width': rankWidth + 'px' }">
        <template v-for="(item, index) in codes">
          <content-name :key="index" :code="item" :name="contents[item]" />
          <span
            :key="index"
            v-if="index !== codes.length - 1 && codes.length > 1"
            class="mh8 yxtbiz-rank__secondary-content-vertical-bar"
          ></span>
        </template>
      </div>
    </div>
    <div class="font-size-14 lh20 mt6">
      <template v-for="(item, index) in codes">
        <content-name :key="index" :code="item" :name="contents[item]" />
        <span
          v-if="index !== codes.length - 1 && codes.length > 1"
          :key="index"
          class="mh8 yxtbiz-rank__secondary-content-vertical-bar"
        ></span>
      </template>
    </div>
  </yxtf-tooltip>
</template>
<script>
import contentName from './contentName.vue';

export default {
  components: {
    contentName
  },
  props: {
    // 类型
    codes: {
      type: Array,
      default: () => []
    },
    // 内容
    contents: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      rankWidth: 0
    };
  },
  mounted() {
    this.rankWidth = this.$parent.$el.clientWidth * 0.7;
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
